import { Button } from '@monorepo/shared/componentsV2/Button';
import { Description } from '@monorepo/shared/componentsV2/Description';
import { SectionContainer } from '@monorepo/shared/componentsV2/fullPageWizard/styled/fullPageWizard';
import { Input } from '@monorepo/shared/componentsV2/Input';
import styled from 'styled-components';

export const BackButton = styled(Button)`
  min-width: 2rem;

  & svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

export const ButtonContainer = styled.div`
  min-width: 4.25rem;
`;

export const ComplianceInput = styled(Input)`
  width: 18rem;
`;

export const StyledSection = styled(SectionContainer)`
  display: flex;
  flex-direction: column;
  max-width: 38rem;
`;

export const FieldContainer = styled.ul`
  padding: 0;
  margin: 0;
`;

export const InstructionsContainer = styled(Description)`
  margin: 0 0 0.5rem;
  color: ${({ theme }) => theme.colors.gray333};
`;
